export default __webpack_public_path__ + "static/media/savemymoney.7f997239.PNG";